import React, { useState } from 'react';

const ServicesSearch = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchClick = () => {
        alert(`Search clicked! Searching for: ${searchTerm}`);
    };

    const inputStyles = {
        padding: '10px',
        fontSize: '16px',
        border: '2px solid #ccc',
        borderRadius: '25px',
        width: "900px",
        transition: 'border-color 0.3s ease',
    };

    const buttonStyles = {
        backgroundColor: '#007bff',
        color: 'white',
        fontSize: '18px',
        fontWeight: 'bold',
        padding: '12px 40px',
        marginLeft: '10px',
        border: 'none',
        borderRadius: '25px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, transform 0.2s ease',
    };

    const buttonHoverStyles = {
        backgroundColor: '#0056b3',
        transform: 'scale(1.05)',
    };

    return (
        <div className="page-wrapper m-0 ps-5 mt-5">
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3 text-primary fw-bold fs-4">Services</div>
                    <div className="search-container d-flex ps-2">
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Enter Serial No#"
                            style={inputStyles}
                            onFocus={(e) => e.target.style.borderColor = '#007bff'}
                            onBlur={(e) => e.target.style.borderColor = '#ccc'}
                        />
                        <button
                            onClick={handleSearchClick}
                            style={buttonStyles}
                            onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverStyles.backgroundColor}
                            onMouseOut={(e) => e.target.style.backgroundColor = buttonStyles.backgroundColor}
                            onMouseDown={(e) => e.target.style.transform = buttonHoverStyles.transform}
                            onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                        >
                            Search
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServicesSearch;
